export default {
  name: 'transaction_customer_address_country',
  component_path: 'modules/procedures/blocks/BlockInputSelectCountry',
  static_options: {
    autocomplete: 'shipping country'
  }
}